<template>
    <div
        v-if="selectedActivations.length > 0"
        class="w-full flex flex-col sm:flex-row sm:justify-between sm:items-center my-lg p-lg bg-white shadow rounded-xl"
    >
        <div>
            Med markerade ({{ selectedActivations.length }} st):
        </div>
        <div>
            <input
                v-for="activationId in selectedActivations"
                :value="activationId"
                type="hidden"
                name="activations[]"
            >
            <label class="mr-sm">
                Tilldelning:
            </label>
            <select
                name="assignee"
                class="mr-sm"
            >
                <option value="none">Ingen</option>
                <option value="company">UE</option>
                <option value="project_manager">PL</option>
                <!--<option value="internal">Teknik</option>-->
            </select>
            <button class="btn btn-md is-primary w-full sm:w-auto">
                Tilldela
            </button>
        </div>
    </div>
</template>

<script>
    import { without } from 'lodash-es';

    Vue.prototype.$activationExceptionsEventBus = new Vue();

    export default {
        data() {
            return {
                selectedActivations: [],
            };
        },
        created() {
            this.$activationExceptionsEventBus.$on('toggleActivationSelected', this.toggle);
        },
        beforeDestroy() {
            this.$activationExceptionsEventBus.$off('toggleActivationSelected');
        },
        methods: {
            toggle: function (activationId, isSelected) {
                if (isSelected) {
                    this.selectedActivations.push(activationId);
                } else {
                    this.selectedActivations = without(this.selectedActivations, activationId);
                }
            },
        },
    };
</script>
